import React from 'react'
import WufooForm from 'react-wufoo-embed'
import Layout from '../components/layout'
import SEO from '../components/seo'

const ContactPage = () => (
  <Layout>
    <SEO 
      title="Contact Us"
      description="Contact Lawrence Hoffman, CPA, PC for a free consultation. Located in Roslyn, NY, serving the tri-state area. Call (516) 625-9051 or visit our office."
      pathname="/contact/"
    />

    <div className="contact-hero">
      <h1>Contact Us</h1>
      <p className="contact-subtitle">
        We're here to help with all your accounting needs. Reach out today for a free consultation.
      </p>
    </div>

    <div className="contact-grid">
      <div className="contact-info">
        <div className="contact-card">
          <h2>Call Us</h2>
          <p className="contact-phone">
            <a href="tel:+15166259051">(516) 625-9051</a>
          </p>
        </div>

        <div className="contact-card">
          <h2>Visit Our Office</h2>
          <address className="contact-address">
            <strong>Lawrence Hoffman, CPA, PC</strong><br />
            30 Ursula Drive<br />
            Roslyn, NY 11576-3021
          </address>
        </div>

        <div className="contact-card highlight">
          <h2>Free Consultation</h2>
          <p>
            Not sure where to start? Schedule a free consultation to discuss 
            your accounting needs with one of our experienced CPAs.
          </p>
        </div>
      </div>

      <div className="contact-form-section">
        <h2>Send Us a Message</h2>
        <p>
          Fill out the form below and we'll get back to you.
        </p>
        <div className="form-wrapper">
          <WufooForm userName="tekmaven" formHash="q11wvsdc0v27rm1" header="hide" />
        </div>
      </div>
    </div>
  </Layout>
)

export default ContactPage
